var d={Switch:"lds-switch",disabled:"lds-switch--disabled"};export{d as default};
